// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { GoogleOAuthProvider } from "@react-oauth/google"; // npm i @react-oauth/google
import { AuthProvider } from "./auth/AuthContext";         // file you created

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="310025268882-o234badv0tol4lg7sqppraajuetj7obb.apps.googleusercontent.com">
  <AuthProvider>
    <App />
  </AuthProvider>
</GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
